import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

import CategoriesDetailpage from "../views/categories/CategoriesDetail";
import Categories from "../views/categories/Categories";
import Loader from "../components/loaderspinnercomponents/Loader";
import { Homepage } from "../views/home/Home";

import {
  CONTRY_CITY_CHECK_API,
  GET_CATEGORIES_API,
  GET_BLOG_CHECK_API,
} from "../config/config";
import { BlogDetail } from "../views/blog/BlogDetail";

const DynamicRouteHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [classify, setClassify] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [isValidCity, setIsValidCity] = useState(false);

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const firstSlug = pathSegments[0] || "";
  const secondSlug = pathSegments[1] || "";
  const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const capitalizedSlug = capitalizeFirstLetter(firstSlug);

  useEffect(() => {
    let isMounted = true;
    const checkRouting = async () => {
      try {
        setLoading(true);

        // Case 1: Single slug (e.g., /saree)
        if (!secondSlug) {
          // 1. Check for City
          try {
            const cityRes = await axios.post(CONTRY_CITY_CHECK_API, {
              slug: firstSlug,
            });
            if (["country", "city"].includes(cityRes?.data?.classify)) {
              if (isMounted) {
                setSelectedLocation(firstSlug);
                setIsValidCity(true);
                setClassify("Homepage");
                localStorage.setItem("country_name", capitalizedSlug);
                localStorage.setItem("city_name", capitalizedSlug);
              }
              return;
            }
          } catch (error) {
            // localStorage.removeItem("city_name");
            // localStorage.removeItem("country_name");
          }

          // 2. Check for Blog
          let blogslug = decodeURIComponent(firstSlug);
          try {
            const blogRes = await axios.post(GET_BLOG_CHECK_API, {
              slug: blogslug,
            });
            if (blogRes?.data?.DATA?.classify === "BlogDetails") {
              if (isMounted) {
                setClassify("BlogDetails");
              }
              return;
            }
          } catch (error) { }

          // 3. Check for Category
          try {
            const catRes = await axios.post(GET_CATEGORIES_API, {
              slug: firstSlug,
            });
            if (isMounted) {
              setClassify(catRes?.data?.DATA?.classify);
              setIsValidCity(false);
            }
            return;
          } catch (error) {
            navigate("/", { replace: true });
            return;
          }
        }

        // Case 2: Two slugs (e.g., /surat/saree)
        if (secondSlug) {
          try {
            const cityRes = await axios.post(CONTRY_CITY_CHECK_API, {
              slug: firstSlug,
            });
            if (["country", "city"].includes(cityRes?.data?.classify)) {
              if (isMounted) {
                setSelectedLocation(firstSlug);
                setIsValidCity(true);
                localStorage.setItem("country_name", capitalizedSlug);
                localStorage.setItem("city_name", capitalizedSlug);
              }

              // 3. Check for Category
              try {
                const catRes = await axios.post(GET_CATEGORIES_API, {
                  slug: secondSlug,
                });
                if (isMounted) {
                  setClassify(catRes?.data?.DATA?.classify);
                }
                return;
              } catch (error) {
                navigate(`/${firstSlug}`, { replace: true });
                return;
              }
            } else {
              navigate("/", { replace: true });
              return;
            }
          } catch (error) {
            navigate("/", { replace: true });
            return;
          }
        }
      } catch (error) {
        console.error("Routing error:", error);
        navigate("/", { replace: true });
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    checkRouting();

    return () => {
      isMounted = false;
    };
  }, [firstSlug, secondSlug, navigate]);

  if (loading) return <Loader />;

  // Render according to classification:
  if (!secondSlug) {
    if (classify === "Category" || classify === "Subcategory") {
      return (
        <Categories
          selectedLocation="/"
          categoryName={firstSlug}
          cityName={null}
        />
      );
    } else if (classify === "CategoryDetail") {
      return (
        <CategoriesDetailpage
          selectedLocation="/"
          slug={firstSlug}
          cityName={null}
        />
      );
    } else if (classify === "BlogDetails") {
      return <BlogDetail slug={firstSlug} />; // passing slug for blog details
    } else if (isValidCity) {
      return <Homepage selectedLocation={firstSlug} />;
    }
  } else {
    if (classify === "Category" || classify === "Subcategory") {
      return (
        <Categories
          selectedLocation={firstSlug}
          categoryName={secondSlug}
          cityName={firstSlug}
        />
      );
    } else if (classify === "CategoryDetail") {
      return (
        <CategoriesDetailpage
          selectedLocation={firstSlug}
          slug={secondSlug}
          cityName={firstSlug}
        />
      );
    } else if (classify === "BlogDetails") {
      return <BlogDetail slug={secondSlug} />;
    }
  }

  // fallback
  return <Homepage selectedLocation="/" />;
};

export default DynamicRouteHandler;
